import styles from './modal.module.scss';
import MaterialModal from '@mui/material/Modal';

/* eslint-disable-next-line */
export interface ModalProps {
  children: any,
  open: boolean,
  // BackdropComponent?: any,
  // BackdropProps?: any,
  // classes?: object,
  // closeAfterTransition?: boolean,
  // component?: any,
  // components?: any,
  // componentsProps?: any,
  // container?: any,
  // disableAutoFocus?: boolean,
  // disableEnforceFocus?: boolean,
  // disableEscapeKeyDown?: boolean,
  // disablePortal?: boolean,
  // disableRestoreFocus?: boolean,
  // disableScrollLock?: boolean,
  // hideBackdrop?: boolean,
  // keepMounted?: boolean,
  // onBackdropClick?: any,
  onClose?: (event: object, reason: string) => void,
  sx?: any
}

export function Modal(props: ModalProps) {
  return (
    <MaterialModal
      open={props.open}
      onClose={props.onClose}
      sx={props.sx}>
      {props.children}
    </MaterialModal>
  );
}

export default Modal;